import {
  Command,
  Disruption,
  Gauri,
  Resilience,
  SimulationWorld,
  Snop,
} from "../../../assets/svg-icons";
import { processNodeAndPermissions } from "../../../helper/com-helper";
import { DT } from "./DT";

const RISKAI_OBJECT = {
  name: "Risk Management & Digital Twin",
  route: "/riskai",
  permissions: [],
  child: {
    // "Command Center": {
    //   name: "Command Center",
    //   shortName: "CC",
    //   route: "/riskai/reports",
    //   icon: Command,
    //   permissions: ["RISK_COMMAND_CENTRE_VIEW"],
    // },
    // "S&OE Dashboard": {
    //   name: "S&OE Dashboard",
    //   shortName: "S&OE",
    //   route: "/riskai/soe",
    //   icon: Snop,
    //   permissions: ["RISK_SOE_VIEW"],
    // },

    "Resilience Monitoring": {
      name: "Resilience Monitoring",
      shortName: "RM",
      route: "/riskai/resilienceoverall",
      icon: Resilience,
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    "Disruption Management": {
      name: "Disruption Management",
      shortName: "DM",
      route: "/riskai",
      icon: Disruption,
      permissions: ["RISK_DISRUPTION_VIEW"],
    },
    GAURI: {
      name: "GAURI",
      shortName: "Gauri",
      route: "/riskai/gauri",
      icon: Gauri,
      permissions: ["RISK_GAURI_VIEW"],
    },
    "Digital Twin": DT,
    "Simulation World Engine": {
      name: "Simulation World Engine",
      shortName: "SWE",
      route: "/riskai/worldengine",
      icon: SimulationWorld,
      permissions: ["RISK_SWE_VIEW"],
    },
  },

  extraRoutes: [
    {
      route: "/riskai/riskdetails",
      permissions: ["RISK_DISRUPTION_VIEW"],
    },
    {
      route: "/riskai/supplier",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/manufacturing",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/transportation",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/warehouse",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/customer",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/fginventory",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/rminventory",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
    {
      route: "/riskai/demand",
      permissions: ["RISK_RESILIENCE_VIEW"],
    },
  ],
};

processNodeAndPermissions(RISKAI_OBJECT);
export const RISKAI = RISKAI_OBJECT;